import { useQuery } from '@tanstack/react-query'

import { installationStore } from '@modules/Installations/store/installationStore'

import { getRobotTypes } from '@context/RobotTypes/application/getRobotTypes'
import { RobotTypeStatus } from '@context/RobotTypes/domain/RobotType'

const ROBOT_TYPES_STALE_TIME = 5 * 60 * 1000

export const useGetRobotTypes = (status?: RobotTypeStatus, options?: { enabled?: boolean }) => {
  const { repository } = installationStore()

  const robotTypesHandler = async ({ queryKey }: { queryKey: [string, { status?: RobotTypeStatus }] }) => {
    return getRobotTypes(repository, queryKey[1].status)
  }

  return useQuery({
    queryKey: ['robotTypes', { status }],
    queryFn: robotTypesHandler,
    staleTime: ROBOT_TYPES_STALE_TIME,
    enabled: options?.enabled ?? true,
  })
}
